import { useMemo } from 'react';
import { MdOutlineArrowRightAlt } from 'react-icons/md';
import { TmdxAvatar } from '@ds';
import { ChangeLogValues, ModifiedLogValue } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/utils';

type ChangedFieldValueProps = ChangeLogValues<ModifiedLogValue | null>;

export const ChangedFieldValue = ({ leftValue, rightValue }: ChangedFieldValueProps) => {
  const left = useMemo(() => {
    if (!leftValue && rightValue?.title) {
      return rightValue;
    }

    return leftValue;
  }, [leftValue, rightValue]);

  const right = useMemo(() => {
    if (!leftValue && rightValue?.title) {
      return {
        type: 'text',
        title: 'Added',
      } as ModifiedLogValue;
    }

    if (!rightValue && leftValue?.title) {
      return {
        type: 'text',
        title: 'Removed',
      } as ModifiedLogValue;
    }

    return rightValue;
  }, [leftValue, rightValue]);

  return (
    <div className="flex gap-x-2 gap-y-1 flex-wrap items-center">
      {!!left && left?.type !== 'text' && (
        <div className="flex gap-1.5 items-center">
          <TmdxAvatar size="md" radius="full" type={left.type} name={left.title} src={left.imageUrl} />
          <span className="text-m-m text-base-5">{left.title}</span>
        </div>
      )}
      {left && left?.type === 'text' && <span className="text-m-m text-base-5 break-all">{left.title}</span>}
      <MdOutlineArrowRightAlt size={16} className="text-base-5 inline" />
      {!!right && right?.type !== 'text' && (
        <div className="flex gap-1.5 items-center">
          <TmdxAvatar size="md" radius="full" type={right.type} name={right.title} src={right.imageUrl} />
          <span className="text-m-m text-base-5">{right.title}</span>
        </div>
      )}
      {!!right && right?.type === 'text' && <span className="text-m-m text-base-5 break-all">{right.title}</span>}
    </div>
  );
};
